import { render, staticRenderFns } from "./CrearDescansoMedico.vue?vue&type=template&id=249642d9"
import script from "./CrearDescansoMedico.vue?vue&type=script&lang=js"
export * from "./CrearDescansoMedico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports